import axios from 'axios'
import { ErrorWrapper, ResponseWrapper } from './util'
import storeHelper from '@/store/helper'
import { JOGET_API_URL } from '../env.js'
import { BaseService } from './base.service'

export class JogetService extends BaseService {
  static async completeActivity(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.complete-activity'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }
  static async getActivity(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-activity'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getVariable(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-variable'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadFile(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.upload-image'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async startProcess(processDefId, params) {
    const token = Buffer.from(`admin:admin`).toString('base64')
    try {
      const response = await axios.post(
        `${JOGET_API_URL}/jw/web/json/workflow/process/start/${processDefId}`,
        params,
        {
          headers: {
            Authorization: 'Basic ' + token,
          },
        }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }

  static async getVariableProcess(processId) {
    const token = Buffer.from(`admin:admin`).toString('base64')
    try {
      const response = await axios.get(
        `${JOGET_API_URL}/jw/web/json/workflow/variable/list/${processId}`,
        {
          headers: {
            Authorization: 'Basic ' + token,
          },
        }
      )
      return new ResponseWrapper(response, response.data)
    } catch (error) {
      throw new ErrorWrapper(error)
    }
  }
}
